export default __webpack_public_path__ + "assets/23df69cde42ae50433820c38f8de6a02.png";